<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-10-26 14:07:17
 * @LastEditors: 陈红伟 chenhw2019@gmail.com
 * @LastEditTime: 2024-01-10 17:55:32
 * @FilePath: /chaoyongtuan/src/views/shopManage/commercialHigh/components/myPromonteGoods/tableCells/goodsContacts.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>
        <div class="fz-12 font-h6-regular contact-name">{{ row.contactName | formatEmpty }}</div>
        <rd-text :label="'手机号'" :showCopy="true" :value="row.mobile | formatEmpty" class="rd-text font-h6-regular"></rd-text>
    </div>
</template>
<script>
import mixin from '@/components/tableCells/mixin.js';
export default{
    mixins: [mixin], 
    data(){
        return{}
    }
}
</script>
<style lang="less" scoped>
.contact-name{
    color: @color-gy9;
}

.rd-text:hover{
    /deep/ .copy-wrapper{
        opacity: 1;
    }
}
/deep/ .copy-wrapper:hover{
    .copy-hover{
        color: @color-primary !important;
    }
}
</style>